module.exports = "/_next/static/images/Alexandru_Buse-2301e1921da5b9bf76e05cc0b98b1854.webp";